import React from "react";

export const MembersIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_20989_17642)">
        <path
          d="M1.33325 14.9792C1.33325 12.0336 3.72107 9.64582 6.66659 9.64582C9.61212 9.64582 11.9999 12.0336 11.9999 14.9792H10.6666C10.6666 12.77 8.87572 10.9792 6.66659 10.9792C4.45745 10.9792 2.66659 12.77 2.66659 14.9792H1.33325ZM6.66659 8.97916C4.45659 8.97916 2.66659 7.18916 2.66659 4.97916C2.66659 2.76916 4.45659 0.979156 6.66659 0.979156C8.87659 0.979156 10.6666 2.76916 10.6666 4.97916C10.6666 7.18916 8.87659 8.97916 6.66659 8.97916ZM6.66659 7.64582C8.13992 7.64582 9.33325 6.45249 9.33325 4.97916C9.33325 3.50582 8.13992 2.31249 6.66659 2.31249C5.19325 2.31249 3.99992 3.50582 3.99992 4.97916C3.99992 6.45249 5.19325 7.64582 6.66659 7.64582ZM12.1891 10.1144C14.0429 10.9499 15.3333 12.8138 15.3333 14.9792H13.9999C13.9999 13.3552 13.0321 11.9572 11.6418 11.3306L12.1891 10.1144ZM11.7307 2.58796C13.0629 3.13718 13.9999 4.44823 13.9999 5.97916C13.9999 7.89262 12.5361 9.46262 10.6666 9.63089V8.28889C11.7977 8.12729 12.6666 7.15516 12.6666 5.97916C12.6666 5.05872 12.1343 4.26318 11.3606 3.88339L11.7307 2.58796Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_20989_17642">
          <rect
            width="16"
            height="16"
            fill="currentColor"
            transform="translate(0 0.3125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
